import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, Phone } from "lucide-react";
import { scrollToSection } from "./shared";

const LINKS = [
  { label: "Services", hash: "#services" },
  { label: "Technician", hash: "#technician" },
  { label: "Hours", hash: "#contact" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);

  const go = (e, hash) => {
    setOpen(false);
    scrollToSection(e, hash);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-void/85 backdrop-blur-xl">
      <nav className="mx-auto flex h-16 max-w-[1500px] items-center justify-between px-5 sm:px-8 lg:px-14">
        <a
          href="#top"
          data-testid="nav-brand-logo"
          onClick={(e) => go(e, "#top")}
          className="flex items-center gap-3"
        >
          <span className="grid h-8 w-8 place-items-center rounded-lg bg-gold font-display text-sm text-zinc-950">
            HG
          </span>
          <span className="font-display text-sm tracking-wide text-zinc-50 sm:text-base">
            HIS GRACE AUTO REPAIR
          </span>
        </a>

        <div className="hidden items-center gap-8 md:flex">
          {LINKS.map((l) => (
            <a
              key={l.hash}
              href={l.hash}
              onClick={(e) => go(e, l.hash)}
              className="group relative text-sm text-zinc-300 transition-colors hover:text-white"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-royal transition-all duration-300 group-hover:w-full" />
            </a>
          ))}
        </div>

        <div className="hidden items-center md:flex">
          <a
            href="tel:+17323392277"
            data-testid="nav-phone-link"
            className="flex items-center gap-2 text-sm text-zinc-100 transition-colors hover:text-gold"
          >
            <Phone size={15} className="text-gold" />
            732-339-2277
          </a>
        </div>

        <button
          className="text-zinc-300 md:hidden"
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </nav>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: -12 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -12 }}
            transition={{ duration: 0.25 }}
            className="border-t border-line/60 bg-void/95 backdrop-blur-xl md:hidden"
          >
            <div className="flex flex-col gap-1 px-6 py-6">
              {LINKS.map((l) => (
                <a
                  key={l.hash}
                  href={l.hash}
                  onClick={(e) => go(e, l.hash)}
                  className="py-3 font-display text-2xl uppercase text-zinc-200"
                >
                  {l.label}
                </a>
              ))}
              <a
                href="tel:+17323392277"
                className="flex items-center gap-2 py-3 text-sm text-zinc-300"
                data-testid="nav-mobile-phone-link"
              >
                <Phone size={15} className="text-gold" /> 732-339-2277
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
